<template>
  <div class="origins-wrapper">
    <!-- ORIGINS -->
    <div class="table-wrapper origins">
      <div>
        <b-button
          v-if="$can('create', 'origins', 'cdn')"
          variant="bg-primary"
          @click="onCreateOrigin()"
        >
          <GjIcon
            class="icon-left"
            name="Plus"
          />
          Create Origin
        </b-button>
        <b-button
          v-if="$can('update', 'origins', 'cdn')"
          variant="bg-white"
          :disabled="!isSelected"
          class="d-none d-lg-inline"
          @click="onEditClick(selected[0].originId)"
        >
          Edit
        </b-button>
        <button-loading
          v-if="$can('delete', 'origins', 'cdn')"
          variant="bg-white"
          :disabled="!isSelected"
          :spinning="removingOrigin"
          class="d-none d-lg-inline"
          @click="onDeleteClick(selected[0].id)"
        >
          Delete
        </button-loading>
      </div>
      <!-- DESKTOP -->
      <div class="default-table position-relative d-none d-lg-block">
        <b-table
          ref="table"
          :items="origins"
          :fields="originFields"
          select-mode="single"
          show-empty
          selectable
          responsive
          :class="{ loaded: !loading }"
          :busy="loading"
          @row-selected="onRowSelected"
        >
          <template #cell(selected)="{ rowSelected }">
            <select-button :selected="rowSelected" />
          </template>

          <template #empty>
            <div
              v-if="loading"
              class="loading-table text-center py-1"
            >
              <b-spinner variant="primary" />
            </div>
            <template v-else>
              <no-data
                no-data-text="No distribution origins have been added yet..."
                create-text="+ Create Origin"
                access-page="Origins"
                :has-permissions="hasOriginPermissions"
                @action="onCreateOrigin()"
              />
            </template>
          </template>
        </b-table>
        <table-busy v-if="loading && origins.length > 0" />
      </div>
      <!-- MOBILE -->
      <div class="position-relative d-lg-none mt-2">
        <div :class="{ 'opacity-7': loading || removingOrigin }">
          <template v-for="origin in origins">
            <card
              :key="origin.id"
              :fields="originFields"
              :item="origin"
              class="top-fade-in"
            >
              <template #options>
                <b-dropdown
                  id="dropdown-1"
                  right
                  variant="white"
                >
                  <template #button-content>
                    <GjIcon name="Moreoptions" />
                  </template>
                  <b-dropdown-item
                    v-if="$can('update', 'origins', 'cdn')"
                    @click="onEditClick(origin.originId)"
                  >
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="$can('delete', 'origins', 'cdn')"
                    @click="onDeleteClick(origin.id)"
                  >Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </card>
          </template>
        </div>
        <div
          v-if="loading || removingOrigin"
          class="mobile-loading"
        >
          <table-busy />
        </div>
        <template v-if="origins.length < 1">
          <div
            v-if="loading"
            class="empty-loading-table"
          />
          <paper-simple
            v-else
            class="top-fade-in"
          >
            <no-data
              class="text-center"
              no-data-text="No distribution origins have been added yet..."
              create-text="+ Create Origin"
              access-page="Origins"
              :has-permissions="hasOriginPermissions"
              @action="onCreateOrigin()"
            />
          </paper-simple>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/card/Card.vue'

export default {
  name: 'Origins',
  components: {
    Card,
  },
  data() {
    return {
      id: null,
      selected: [],
      originFields: [
        {
          key: 'id',
          thClass: 'd-none',
          tdClass: 'd-none',
          hide: true,
        },
        {
          key: 'selected',
          label: '',
          variant: 'select',
          hide: true,
        },
        'originId',
        { key: 'domain', label: 'Origin Domain', isPrimary: true },
        { key: 'path', label: 'Origin Path' },
        { key: 'originType', variant: 'time', isPrimary: true },
      ],
      details: false,
      hasOriginPermissions: true,
    }
  },
  computed: {
    origins() {
      return this.$store.state.cdn.origins
    },
    loading() {
      return this.$store.state.cdn.fetchingOrigins
    },
    isSelected() {
      return this.selected[0]
    },
    removingOrigin() {
      return this.$store.state.cdn.removingOrigin
    },
  },
  created() {
    this.id = this.$route.params.id
    this.dispatchOrigins()
  },
  methods: {
    onRowSelected(item) {
      this.selected = item
    },
    dispatchOrigins() {
      this.$store.dispatch('cdn/fetchOrigins', this.id).catch(error => {
        if (error.response?.status === 403) {
          this.hasOriginPermissions = false
          return
        }
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching origins.',
        )
      })
    },
    onEditClick(originId) {
      this.$router.push({
        name: 'distribution-origins-edit',
        params: { id: this.id, originId },
      })
    },
    onCreateOrigin() {
      this.$router.push({
        name: 'distribution-origins-create',
        params: { id: this.id },
      })
    },
    onDeleteClick(originId) {
      this.confirmDelete(
        'Delete Origin',
        'Are you sure you want to delete this origin?',
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('cdn/removeOrigin', {
              distributionId: this.id,
              id: originId,
            })
            .then(() => {
              this.successToast('Origin was removed')
              this.selected = []
            })
            .catch(error => {
              this.errorToast(
                error.response?.data?.errors[0] || 'Something went wrong.',
              )
            })
        }
      })
    },
  },
}
</script>
